export default function round(a) {
  return Math.round(a[0])
}
